export default {"src":"/_next/static/media/laboratory-hpv.b1a440c7.svg","height":321,"width":248,"blurWidth":0,"blurHeight":0};